import { Debug } from "./debug";
import { checkEmpty } from "./stringutil";

export function getApiHostname() {
  try {
    return (process.env.NEXT_PUBLIC_LOCAL ?? false)
      ? "https://" + (window?.location?.hostname ?? "localhost") + (checkEmpty(process.env.NEXT_PUBLIC_CLMAPIPORT) ? "" : ":" + process.env.NEXT_PUBLIC_CLMAPIPORT)
      : process.env.NEXT_PUBLIC_CLMAPINAME === "api"
        ? "https://" +
          (window?.location?.hostname ? "api." + window?.location?.hostname : "api.coffeein.site") +
          (checkEmpty(process.env.NEXT_PUBLIC_CLMAPIPORT) ? "" : ":" + process.env.NEXT_PUBLIC_CLMAPIPORT)
        : process.env.NEXT_PUBLIC_CLMHOST; //name + port 구조임
  } catch (err) {
    return process.env.NEXT_PUBLIC_CLMHOST;
  }
}
export function getParamsValue(param: string): string | null {
  const search = window.location.search;
  let paramValue: string | null = null;
  if (search != null && search.indexOf("?") > -1) {
    const start = search.indexOf(param + "=");
    if (start > 0) {
      const end = search.indexOf("&", start);
      if (end > 0) {
        paramValue = search.substring(start + param.length + 1, end);
      } else {
        paramValue = search.substring(start + param.length + 1);
      }
    }
  }
  return paramValue;
}
export function changeSearch(param?: string, value?: string, removeFields?: string[]): string | null {
  let search = window.location.search;
  //Debug(search);
  if (param) {
    const paramValue = getParamsValue(param);
    if (paramValue) {
      if (value) {
        search = search.replace(`${param}=${paramValue}`, `${param}=${value}`);
      } else {
        if (search.indexOf(`&${param}=`) > 0) {
          search = search.replace(`&${param}=${paramValue}`, "");
        } else {
          search = search.replace(`${param}=${paramValue}`, "");
        }
      }
    } else {
      if (value) {
        search = (search == "" ? "?" : search + "&") + `${param}=${value}`;
      }
    }
  }
  if (removeFields) {
    removeFields.forEach((item) => {
      const paramValue = getParamsValue(item);
      // Debug(item, paramValue);
      if (paramValue) {
        if (search.indexOf(`&${item}=`) > 0) {
          search = search.replace(`&${item}=${paramValue}`, "");
        } else {
          search = search.replace(`${item}=${paramValue}`, "");
        }
      }
    });
  }
  if (search == "?") {
    search = "";
  }
  return search;
}
